import * as React from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItemButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { useLocalStorage } from "../auth/useLocalStorage";
import { InventoryService } from "../services/InventoryService";
import { useEffect } from "react";

import AsyncSelect from "react-select/async";
// import { ColourOption, colourOptions } from '../data';
import { productsService } from "../services/productsService";
import { CashBoxTransfer, Details, IProduct } from "../common/interfaces";
import { CommonService } from "../services/CommonService";

interface CloseBoxProps {
  handleCancel: () => void;
}

export default function TransferInventory(props: CloseBoxProps) {
  const { handleCancel } = props;
  const [user, setUser] = useLocalStorage("user", null);
  const [warehouse, setWarehouses] = React.useState(
    `${user?.warehouse_id}` ?? ""
  );
  const [warehouseDestiny, setWarehousesDestiny] = React.useState("");
  const [warehouseList, setWarehouseList] = React.useState<any[]>([]);
  const [products, setProducts] = React.useState<IProduct[]>([]);
  const [productsToTransfer, setProductsToTransfer] = React.useState<any[]>([]);
  const [productsTablajeo, setProductsTablajeo] = React.useState<
    Record<string, any>
  >({});
  const [step, setStep] = React.useState("first");
  const [item, setItem] = React.useState<CashBoxTransfer>();
  const [transferList, setTransferList] = React.useState<any[]>([]);
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [filterType, setFilterType] = React.useState<string>("all");

  const promiseOptions = async (inputValue: string) => {
    const response = await productsService.getProductsByWarehouse(
      inputValue,
      user.warehouse_id
    );
    setProducts(response.data);
    return response.data.map((product: IProduct) => ({
      value: product.id,
      label: product.name,
    }));
  };
  const handleSelectProduct = (e: any) => {
    if(!e) return;

    const newProduct: IProduct = products.find(
      (p) => p.id === e.value
    ) as IProduct;
    const index = productsToTransfer.findIndex((p) => p.id === newProduct.id);
    console.log({ index });
    if (index === -1) {
      setProductsToTransfer([...productsToTransfer, newProduct]);
      setProductsTablajeo({
        ...productsTablajeo,
        [newProduct.id.toString()]: "",
      });
    }

    // Reset the selected product
    setSelectedProduct(null);
  };

  const removeItem = (id: any) => {
    const index = productsToTransfer.findIndex((p) => p.id === id);
    if (index !== -1) {
      const aux = productsToTransfer;
      aux.splice(index, 1);
      setProductsToTransfer([...aux]);
    }

    const { [id]: _, ...remainingProducts } = productsTablajeo;
    setProductsTablajeo(remainingProducts);
  };

  useEffect(() => {
    InventoryService.getWarehouses().then((res) => {
      if (res.length > 0) {
        setWarehouseList(res);
      }
    });
    CommonService.getTransferByCashBox(user.cbox.id).then((res) => {
      if (res.success) {
        setTransferList(res?.object ?? []);
      }
    });
    console.log({ user });
  }, []);

  useEffect(() => {
    console.log({ warehouse });
  }, [warehouse]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // Prevenir doble click
    if (isSubmitting) {
      return;
    }

    const aux = [];
    for (let product in productsTablajeo) {
      if (productsTablajeo[product] === "") {
        CommonService.displayAlert(
          "Debe ingresar la cantidad de cada producto"
        );
        return;
      }
      aux.push({
        id: product,
        quantity: productsTablajeo[product],
      });
    }
    const data = {
      products: aux,
      user_id: user.id,
      origin_warehouse_id: warehouse,
      destiny_warehouse_id: warehouseDestiny,
      status: "Completado",
      comments: "Creado POS",
      is_pos: 1,
      cash_box_id: user.cbox.id,
    };

    // Activar estado de loading
    setIsSubmitting(true);

    CommonService.addTranserProcess(data).then((res) => {
      CommonService.displayAlert(res.message);
      if (res.success) {
        handleCancel();
      }
    }).finally(() => {
      // Desactivar estado de loading
      setIsSubmitting(false);
    });
  };
  return (
    <>
      {step === "first" && (
        <div style={{ textAlign: "center" }}>
          <Typography style={{ textAlign: "left" }}>
            <Button
              style={{ float: "right" }}
              hidden={true}
              onClick={() => setStep("createTransfer")}
            >
              Crear Transferencia de Inventario
            </Button>
          </Typography>

          {/* Filtros */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 2 }}>
            <ToggleButtonGroup
              value={filterType}
              exclusive
              onChange={(event, newFilter) => {
                if (newFilter !== null) {
                  setFilterType(newFilter);
                }
              }}
              aria-label="filtro de transferencias"
            >
              <ToggleButton value="all" aria-label="todas">
                Todas
              </ToggleButton>
              <ToggleButton value="receiving" aria-label="para recibir">
                Para Recibir
              </ToggleButton>
              <ToggleButton value="sent" aria-label="enviadas">
                Enviadas
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <List style={{ width: "100%" }} component="div">
                {transferList &&
                  transferList
                    .filter((item: any) => {
                      const isReceiving = item.transfer.origin_warehouse_id !== user.warehouse_id;
                      if (filterType === "receiving") return isReceiving;
                      if (filterType === "sent") return !isReceiving;
                      return true; // "all"
                    })
                    .map((item: any) => {
                    const isReceiving = item.transfer.origin_warehouse_id !== user.warehouse_id;
                    const originWarehouse = warehouseList.find(w => w.id === item.transfer.origin_warehouse_id);
                    const destinyWarehouse = warehouseList.find(w => w.id === item.transfer.destiny_warehouse_id);
                    const createdDate = new Date(item.transfer.created_at);
                    const formattedDate = createdDate.toLocaleDateString('es-MX', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    });
                    const formattedTime = createdDate.toLocaleTimeString('es-MX', {
                      hour: '2-digit',
                      minute: '2-digit'
                    });

                    return (
                      <div key={item.id} style={{ width: "100%" }}>
                        <ListItemButton
                          onClick={() => {
                            if (item.transfer.status !== "Pendiente") {
                              CommonService.displayAlert(
                                "Transferencia Completada"
                              );
                              return;
                            }
                            if (!isReceiving) {
                              CommonService.displayAlert(
                                "No puedes transferir a tu mismo almacen"
                              );
                              return;
                            }
                            setItem(item);
                            setStep("confirmTransfer");
                          }}
                          sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "flex-start" }}
                        >
                          <div style={{ width: "100%", display: "flex", alignItems: "center", marginBottom: "8px" }}>
                            <div style={{ width: "100%" }}>
                              T - {item.id}
                              <span style={{
                                marginLeft: "10px",
                                padding: "2px 8px",
                                borderRadius: "4px",
                                fontSize: "0.85em",
                                backgroundColor: isReceiving ? "#2196f3" : "#ff9800",
                                color: "white"
                              }}>
                                {isReceiving ? "Para Recibir" : "Enviada"}
                              </span>
                              <span style={{
                                marginLeft: "10px",
                                padding: "2px 8px",
                                borderRadius: "4px",
                                fontSize: "0.85em",
                                backgroundColor: item.transfer.status === "Pendiente" ? "#f44336" : "#4caf50",
                                color: "white"
                              }}>
                                {item.transfer.status}
                              </span>
                            </div>
                          </div>
                          <div style={{ width: "100%", display: "flex", fontSize: "0.85em", color: "#fff", gap: "20px" }}>
                            <div>
                              <strong>Fecha:</strong> {formattedDate} {formattedTime}
                            </div>
                            <div>
                              <strong>Origen:</strong> {originWarehouse?.name || "N/A"}
                            </div>
                            <div>
                              <strong>Destino:</strong> {destinyWarehouse?.name || "N/A"}
                            </div>
                            <div>
                              <strong>Creado por:</strong> {item.transfer.user?.nombre || item.transfer.created_by || "N/A"}
                            </div>
                          </div>
                        </ListItemButton>
                        <Divider />
                      </div>
                    );
                  })}
                {transferList && transferList.filter((item: any) => {
                  const isReceiving = item.transfer.origin_warehouse_id !== user.warehouse_id;
                  if (filterType === "receiving") return isReceiving;
                  if (filterType === "sent") return !isReceiving;
                  return true;
                }).length === 0 && (
                  <Typography>
                    {filterType === "receiving" && "No hay Transferencias Para Recibir"}
                    {filterType === "sent" && "No hay Transferencias Enviadas"}
                    {filterType === "all" && "No hay Transferencias Pendientes"}
                  </Typography>
                )}
              </List>
            </Grid>
          </Grid>
          <div style={{ marginTop: "20px" }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => handleCancel()}
            >
              Cancelar
            </Button>
          </div>
        </div>
      )}
      {step === "createTransfer" && (
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <Typography>Transferencia de Inventario</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl fullWidth style={{ marginTop: 20 }}>
                <InputLabel id="demo-simple-select-label">
                  Almacen Origen
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="warehouse"
                  required
                  value={warehouse}
                  onChange={(e) => {
                    if (e.target.value === warehouseDestiny) {
                      setWarehousesDestiny("");
                      CommonService.displayAlert(
                        "El Almacen de Destino no puede ser igual al Almacen de Origen"
                      );
                    } else setWarehouses(e.target.value);
                  }}
                  label="warehouse"
                >
                  {warehouseList.length > 0 &&
                    warehouseList
                      .filter((warehouse) => warehouse.id === user.warehouse_id)
                      .map((warehouse) => (
                        <MenuItem value={warehouse.id} key={warehouse.id}>
                          {warehouse.name}
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth style={{ marginTop: 20 }}>
                <InputLabel id="demo-simple-select-label">
                  Almacen Destino
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="warehouse"
                  required
                  value={warehouseDestiny}
                  onChange={(e) => {
                    if (e.target.value === warehouse) {
                      setWarehousesDestiny("");
                      CommonService.displayAlert(
                        "El Almacen de Destino no puede ser igual al Almacen de Origen"
                      );
                    } else setWarehousesDestiny(e.target.value);
                  }}
                  label="warehouse"
                >
                  {warehouseList.length > 0 &&
                    warehouseList
                      .filter((warehouse) => warehouse.id !== user.warehouse_id)
                      .map((warehouse) => (
                        <MenuItem value={warehouse.id} key={warehouse.id}>
                          {warehouse.name}
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          {warehouseDestiny !== "" && warehouse !== "" && (
            <>
              <hr />
              <AsyncSelect
                cacheOptions
                defaultOptions
                onChange={handleSelectProduct}
                loadOptions={promiseOptions}
                value={selectedProduct}
                placeholder="Busque su Producto"
                styles={{
                  control: (styles) => ({ ...styles }),
                  placeholder: (styles) => ({ ...styles, color: "#000" }),
                  option: (
                    styles,
                    { data, isDisabled, isFocused, isSelected }
                  ) => {
                    return {
                      ...styles,
                      backgroundColor: isDisabled
                        ? undefined
                        : isSelected
                        ? "#ccc"
                        : isFocused
                        ? "#ccc"
                        : undefined,
                      color: isDisabled ? "#ccc" : isSelected ? "#333" : "#333",
                    };
                  },
                }}
              />
            </>
          )}
          <table
            className="table table-striped"
            style={{ marginTop: 20, width: "100%" }}
          >
            {productsToTransfer.map((item: IProduct, index: number) => (
              <tr key={"item" + index}>
                <td>
                  <IconButton
                    aria-label="delete"
                    onClick={() => removeItem(item.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </td>
                <td>
                  <Typography>{item.name}</Typography>
                </td>
                <td>
                  <TextField
                    margin="normal"
                    type="number"
                    required
                    fullWidth
                    id="cards"
                    value={productsTablajeo[item.id.toString()]}
                    onChange={(e) => {
                      setProductsTablajeo({
                        ...productsTablajeo,
                        [item.id.toString()]: e.target.value,
                      });
                    }}
                    label="Cantidad a transferir"
                    name="quantity"
                    autoFocus
                  />
                </td>
              </tr>
            ))}
          </table>
          <div style={{ textAlign: "center" }}>
            <Button
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => {
                setStep("first");
              }}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, mb: 2, ml: 3 }}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Procesando...' : 'Guardar y Salir'}
            </Button>
          </div>
        </Box>
      )}
      {step === "confirmTransfer" && (
        <>
          <div style={{ textAlign: "center" }}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Producto</TableCell>
                    <TableCell>Cantidad</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    item && item.transfer.details.map((detail: Details) => (
                      <TableRow>
                        <TableCell>{detail.product.name}</TableCell>
                        <TableCell>{detail.quantity}</TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
            </TableContainer>

            <div style={{ marginTop: "30px" }}>
              <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => setStep("first")}
                >
                  Regresar
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => {
                    CommonService.confirmTransfer(item?.transfer?.id ?? 0, {user_id: user.user.id}).then(res => {
                      if(res.success){
                        CommonService.displayAlert("Transferencia Completada")
                        setStep("first")
                        // Recargar la lista de transferencias
                        CommonService.getTransferByCashBox(user.cbox.id).then((res) => {
                          if (res.success) {
                            setTransferList(res?.object ?? []);
                          }
                        });
                      }
                    })
                  }}
                >
                  Confirmar Recepción
                </Button>
              </Stack>
            </div>
          </div>
        </>
      )}
    </>
  );
}
